import ImageIcon from '@mui/icons-material/Image'
import { CircularProgress } from '@mui/material'
import classNames from 'classnames'
import React from 'react'
import Color from './LoadingSpinner.colors'
import styles from './LoadingSpinner.module.scss'
import * as Sizes from './LoadingSpinner.sizes'

const defaultProps = Object.freeze({
  size: Sizes.NORMAL as number,
  color: Color.Primary as Color,
})

type Props = typeof defaultProps & {
  margins?: boolean
  classes?: {
    root?: string
    spinner?: string
  }
  imageLoader?: boolean
  message?: React.ReactNode
  relative?: boolean
}

const LoadingSpinner = (props: Props) => {
  const classes = classNames(styles['spinner'], props.classes?.root!, {
    [styles['spinner--margins']]: props.margins,
    [styles['spinner--image']]: props.imageLoader,
    [styles['spinner--image--relative']]: props.relative,
  })

  const loaderClasses = classNames(styles['spinner__loader--base'], {
    [styles['spinner__loader']]: props.imageLoader,
  })
  return (
    <div className={classes}>
      <div className={loaderClasses}>
        <CircularProgress
          size={props.imageLoader ? Sizes.LARGE : props.size}
          color={props.color}
          className={classNames(props.classes?.spinner!)}
          thickness={props.imageLoader ? 1.0 : 1.5}
        />
        {props.imageLoader ? <ImageIcon classes={{ root: styles['loader__image'] }} color="secondary" /> : null}
      </div>

      {props.message ? (
        <>
          <br />
          {props.message}
        </>
      ) : null}
    </div>
  )
}

LoadingSpinner.defaultProps = defaultProps

export { Color, Sizes }
export default LoadingSpinner
